// import request         from '@/request/index.js';
// import responseHandler from '@/utils/responseHandler.js';
import rawRequest      from '@/utils/raw-request.js';
// import data from './data.js';

// const queryVirusTrip = () => {
//   // return request.ticket( {
//   //   url       : '/gateway/dynamic/tool',
//   //   sidFields : [ 'uid', 'pid' ],

//   //   data : {
//   //     pid : '315015'
//   //   }
//   // } ).then( responseHandler.resBdData );

//   const randomNumber = Math.floor( ( Math.random() * 100 ) );

//   if ( randomNumber < 30 ) {
//     return rawRequest( {
//       url : 'https://2019ncov.133.cn/virus-trip/list.json',
//     } ).then( ( result ) => {
//       console.log( result );
//       console.log( result.body.data );
//       return Promise.resolve( result.body.data );
//     } );
//   } else {
//     return Promise.resolve( JSON.parse( data ).data );
//   }
// };

const queryVirusTrip = () => {
  return rawRequest( {
    url : 'https://2019ncov.133.cn/virus-trip/list',
  } ).then( ( data ) => {
    let result;

    console.log( data );
    console.log( data.body.data );
    console.log( '[ queryVirusTrip ]' );

    if ( data && data.body && data.body.data && data.body.data.list ) {
      result = Promise.resolve( data.body.data );
    } else {
      result = Promise.reject( new Error( '请求失败' ) );
    }

    return result;
  } ).catch( () => {
    return rawRequest( {
      url : 'https://2019ncov.133.cn/virus-trip/list.json'
    } ).then( ( data ) => {
      return Promise.resolve( data.body.data );
    } );
  } );
};

export default queryVirusTrip;

// https://cdn.133.cn/gtgj/web/virusTrip
// https://cdn.133.cn/gtgj/web/virusTrip/2019



// WEBPACK FOOTER //
// ./src/projects/virusTrip/service/query-virus-trip.js